export default {
  SET_INITIALIZED_SEA_ROUTE(state, data) {
    state.initializedSeaRoute = data;
  },
  SET_CHANNEL_DATA_MANEUVERING(state, data) {
    state.channelDataManeuvering = data;
  },
  SET_CHANNEL_DATA_ENGINE(state, data) {
    state.channelDataEngine = data;
  },
  SET_CHANNEL_DATA_ALERT(state, data) {
    state.channelDataAlert = data;
  },
  SET_ABNORMAL_MACHINERY(state, data) {
    state.abnormalMachinery = data;
  },
  SET_SEA_ROUTES(state, data) {
    state.seaRoutes = data;
  },
  SET_VEERING_POINTS(state, data) {
    state.veeringPoints = data;
  },
  SET_PASSING_POINTS(state, data) {
    state.passingPoints = data;
  },
  SET_ARRIVAL_POINT(state, data) {
    state.arrivalPoint = data;
  },
  SET_IS_ARRIVED_POINT(state, data) {
    state.isArrivedPoint = data;
  },
  SET_IS_LESS_THAN_1KN(state, data) {
    state.isLessThan1kn = data;
  },
  SET_EVENT_DATA(state, data) {
    state.eventData = data;
  },
  SET_BERTH_MODE(state, data) {
    state.isBerthMode = data;
  },
  SET_LATEST_DEPARTURE_POINT(state, data) {
    state.latestDeparturePoint = data;
  },
  SET_NEXT_ARRIVAL_POINT(state, data) {
    state.nextArrivalPoint = data;
  },
  SET_OTHER_VESSELS_POSITION(state, data) {
    state.otherVesselsPosition = data;
  },
  SET_TRACK_POSITIONS(state, data) {
    state.trackPositions = data;
  },
  SET_TRACK_HISTORIES(state, data) {
    state.trackHistories = data;
  },
  SET_VESSEL_INFO(state, data) {
    state.vesselInfo = data;
  },
  MERGE_TRACK_POSITIONS(state, data) {
    if (state.trackPositions) {
      state.trackPositions.push(data);
    }
  },
  RESET_TRACK_POSITIONS(state) {
    state.trackPositions = [];
  },
  MERGE_GHOST_POSITIONS(state, data) {
    if (state.ghostPositions) {
      state.ghostPositions.push(data);
    }
  },
  RESET_GHOST_POSITIONS(state) {
    state.ghostPositions = [];
  },
  SET_GHOST_POSITIONS(state, data) {
    state.ghostPositions = data;
  },
  PUSH_UNSUBSCRIBE(state, data) {
    state.unsubscribes.push(data);
  },
  UNSUBSCRIBE_FIRE_STORE(state) {
    if (state.unsubscribes.length !== 0) {
      state.unsubscribes.forEach(unsubscribe => {
        unsubscribe();
      });
    }
  },
  SET_JUMP_TO(state, data) {
    state.jumpTo = data;
  },
  SET_CONNECTING_STATE_4G_VSAT(state, data) {
    state.connectingState4gVSAT = data;
  },
  SET_CONNECTING_STATE_SBX(state, data) {
    state.connectingStateSBX = data;
  },
  SET_CONNECTING_STATE_AMS(state, data) {
    state.connectingStateAMS = data;
  },
  SET_INITIAL_FO_FLOW_DATA(state, data) {
    state.initialFOFlowData = data;
  },
  SET_FO_FLOWS_SUM(state, data) {
    state.foFlowsSum = data;
  },
  SET_FO_FLOWS(state, data) {
    state.foFlows = data;
  },
  SET_IS_POSITIONS_UPDATING_BY_API(state, data) {
    state.isPositionsUpdatingByApi = data;
  },
  SET_BEFORE_UPDATING_GHOST_BY_API_DATETIME(state, data) {
    state.beforeUpdatingGhostByApiDatetime = data;
  },
  RESET_STATE(state, data) {
    Object.assign(state, data);
  },
  SET_ENGINE_DATA_FIRST_FETCH_FROM_FIREBASE(state, data) {
    state.engineDataFirstFetchFromFirebase = data
  },
  SET_MANEUVERING_DATA_FIRST_FETCH_FROM_FIREBASE(state, data) {
    state.maneuveringDataFirstFetchFromFirebase = data
  }
};
